import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchDynamicToken = createAsyncThunk(
  'auth/fetchDynamicToken',
  async (_, { getState }) => {
    const { auth } = getState();
    const now = Date.now();

    if (auth.token && auth.expiry && now < auth.expiry) {
      return auth.token;
    }

    const refNum = localStorage.getItem('ref_num');
    if (!refNum) throw new Error('ref_num not found');

    const response = await axios.post(
      `${import.meta.env.VITE_API_URL}/fe-login`,
      { ref_id: refNum },
      { headers: { 'Content-Type': 'application/json' } }
    );

    const token = response?.data?.token;
    if (!token) throw new Error('Token not received');

    return token;
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: null,
    expiry: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearToken: (state) => {
      state.token = null;
      state.expiry = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDynamicToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDynamicToken.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload;
        state.expiry = Date.now() + 10 * 60 * 1000; // 10 minutes
      })
      .addCase(fetchDynamicToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearToken } = authSlice.actions;
export default authSlice.reducer;